import { BaseMole } from "../BaseMole";
import { MoleAnimationController, MoleAnimationState } from "../MoleAnimationController";
import { DieState } from "./DieState";
import { FreezeState } from "./FreezeState";
import { IMoleState } from "./IMoleState";

export class DigInState implements IMoleState {
    private nextState: IMoleState;

    public constructor(
        private readonly mole: BaseMole,
        private readonly animationController: MoleAnimationController,
        private readonly dieState: DieState,
        private readonly freezeState: FreezeState
    ) {
        this.nextState = this;
    }

    public enter(previousState: IMoleState): void {
        this.animationController.onClipEnd.add(this.handleClipEnd, this);
        if (!(previousState instanceof FreezeState)) {
            this.animationController.transitToState(MoleAnimationState.ClimbsIn);
        }
    }

    private handleClipEnd(_state: MoleAnimationState): void {
        this.nextState = null;
    }

    public exit(): void {
        this.animationController.onClipEnd.remove(this.handleClipEnd, this);
    }

    public process(_dt: number): IMoleState {
        if (!this.mole.alive) {
            return this.dieState;
        }
        if (this.mole.freezed) {
            return this.freezeState;
        }
        return this.nextState;
    }

}